import { acceptHMRUpdate, defineStore } from 'pinia'
import { ref } from 'vue'

export const useRealEstateStore = defineStore('realEstate', () => {
  const realEstateGeneral = ref({})
  const realEstatePart1Main = ref([])
  const realEstatePart1Entries = ref([])
  const realEstatePart2 = ref([])
  const realEstatePart3 = ref([])
  const realEstatePart4 = ref([])

  return {
    realEstateGeneral,
    realEstatePart1Main,
    realEstatePart1Entries,
    realEstatePart2,
    realEstatePart3,
    realEstatePart4,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useRealEstateStore, import.meta.hot))
}
